export var EarlyAccessFeature;
(function (EarlyAccessFeature) {
    EarlyAccessFeature["TOKENIZED_ASSETS"] = "TOKENIZED_ASSETS";
})(EarlyAccessFeature || (EarlyAccessFeature = {}));
//# sourceMappingURL=early-access.types.js.map